// extracted by mini-css-extract-plugin
module.exports = {"inactive":"SelectUsers_inactive__3FYbQ","item":"SelectUsers_item__1wdJC","active":"SelectUsers_active__1bqUq","avatar":"SelectUsers_avatar__3hMvh"};